export default __webpack_public_path__ + "cd26a503633175c62ba6c72681a11d1e.svg";